/*!

 =========================================================
 * Vue Paper Dashboard - v2.0.0
 =========================================================

 * Product Page: http://www.creative-tim.com/product/paper-dashboard
 * Copyright 2019 Creative Tim (http://www.creative-tim.com)
 * Licensed under MIT (https://github.com/creativetimofficial/paper-dashboard/blob/master/LICENSE.md)

 =========================================================

 * The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.

 */
import { createApp } from "vue";
import App from "./App.vue";
import router from "./router";
import store from './store/store';
import { reactive } from "vue";

import PaperDashboard from "./plugins/paperDashboard";
import Card from './components/Cards/Card.vue';
import Sidebar from "./components/SidebarPlugin/SideBar.vue";
import SidebarLink from "./components/SidebarPlugin/SidebarLink.vue";

import setupInterceptors from './services/axios/setupInterceptors';
//import ClickOutside from './plugins/clickOutsideDirective'; // Adjust the import path according to your project structure

setupInterceptors(store);

let appInstance = createApp(App);
//appInstance.use(store);
appInstance.use(router);
appInstance.use(PaperDashboard);
appInstance.config.globalProperties.$sidebar = reactive({
    showSidebar: false,
    sidebarLinks: [],
})

appInstance.component("card", Card);
appInstance.component("side-bar", Sidebar);
appInstance.component("sidebar-link", SidebarLink);

//appInstance.directive('click-outside', ClickOutside);
appInstance.mount("#app");
